import { format } from 'date-fns';
import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Toast from 'react-bootstrap/Toast';
import './AddShiftModal.scss';
import { TIME_FORMAT_OUTPUT } from '../../../constants/time';
import { ProviderScheduleWithKey } from '../Scheduler.types';

export type AddShiftModalProps = {
  show: boolean;
  onClose: () => void;
  className?: string;
  schedules?: ProviderScheduleWithKey[];
  title?: string | React.ReactNode;
  onAddFields: (dates: Date[]) => void;
};

export const AddShiftModal = ({
  show,
  onClose,
  title = 'Select Availability Shift',
  schedules,
  onAddFields,
}: AddShiftModalProps) => {
  const [checked, setChecked] = useState<ProviderScheduleWithKey[]>([]);
  const onClick = (event: React.MouseEvent<HTMLInputElement>, value: ProviderScheduleWithKey) => {
    const checked = (event.target as HTMLInputElement).checked;
    setChecked((prevState) => {
      return prevState.map((elem) => {
        return elem.key === value.key ? { ...elem, checked } : elem;
      });
    });
  };

  useEffect(() => {
    setChecked(schedules ?? []);
  }, [schedules]);

  const onSubmit = () => {
    const checkedFields = checked.filter((elem) => elem.checked);
    const checkedDates = checkedFields.map(({ start_on }) => new Date(start_on));

    onAddFields(checkedDates);
    onClose();
  };

  return (
    <Toast show={show} onClose={onClose} className="add-new-shift-modal">
      <header className="header d-flex align-items-center">{title}</header>
      <main className="main">
        {checked?.map((schedule) => {
          return (
            <Form.Check
              key={schedule.key}
              id={schedule.key}
              type="checkbox"
              checked={!!schedule?.checked}
              className="d-flex justify-content-between flex-row-reverse add-new-shift-modal-item"
              onClick={(event) => onClick(event, schedule)}
              label={
                <div className="add-new-shift-modal-label">
                  {`${format(new Date(schedule.start_on), TIME_FORMAT_OUTPUT)}`}
                </div>
              }
            />
          );
        })}
      </main>
      <footer className="footer d-flex align-items-center justify-content-end gap-2">
        <Button variant="outline-primary" onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          disabled={!checked.some((elem) => elem.checked)}
          onClick={onSubmit}
        >
          Add
        </Button>
      </footer>
    </Toast>
  );
};
